import React from "react";
import "./InvestmentSuccess.css";

const InvestmentSuccess = ({ onClose }) => {
    const handleGoHome = () => {
        onClose();
        setTimeout(() => {
            document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    return (
        <div className="investment-success-overlay" onClick={onClose}>
            <div className="investment-success-modal" onClick={(e) => e.stopPropagation()}>
                <div className="success-icon-container">
                    <div className="check-circle animated">
                        <svg viewBox="0 0 24 24" className="check-svg">
                            <path
                                d="M5 13l4 4L19 7"
                                fill="none"
                                stroke="#fff"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="check-path"
                            />
                        </svg>
                    </div>
                </div>

                <h1 className="success-header-title">Investment <br /> Enquiry Received!</h1>

                <p className="success-sub-text">
                    Thank you for your interest in joining the fulupo journey.We have successfully received your investment submission.
                </p>

                <div className="next-steps-card">
                    <h2 className="next-steps-title">what happens next?</h2>

                    <div className="steps-container">
                        <div className="step-item">
                            <div className="step-number">1.</div>
                            <div className="step-content">
                                <h3>Internal View</h3>
                                <p>our investor relations team will review your submission and credentials</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">2.</div>
                            <div className="step-content">
                                <h3>Response Timeline</h3>
                                <p>You will receive a response within 24 hours to 28 hours.</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">3.</div>
                            <div className="step-content">
                                <h3>Email Confirmation</h3>
                                <p>A Confirmation email with further details has been sent to your provided address.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <button className="go-home-btn" onClick={handleGoHome}>
                    Go to Home Page
                </button>
            </div>
        </div>
    );
};

export default InvestmentSuccess;
